const WOWHEAD_SCRIPT_SELECTOR = 'script[data-wowhead-tooltips]'
const WOWHEAD_SCRIPT_URL = 'https://wow.zamimg.com/js/tooltips.js'
const DEFAULT_OPTIONS = {
  colorLinks: false,
  iconizeLinks: false,
  renameLinks: false,
}

export function ensureWowheadTooltips(options = {}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  window.whTooltips = {
    ...(window.whTooltips || {}),
    ...DEFAULT_OPTIONS,
    ...options,
  }

  const existingScript = document.querySelector(WOWHEAD_SCRIPT_SELECTOR)
  if (existingScript) {
    refreshWowheadTooltips()
    return
  }

  const script = document.createElement('script')
  script.src = WOWHEAD_SCRIPT_URL
  script.async = true
  script.dataset.wowheadTooltips = 'true'
  script.addEventListener('load', () => refreshWowheadTooltips())
  document.head.appendChild(script)
}

export function refreshWowheadTooltips({ attempt = 0, maxAttempts = 10, delay = 220 } = {}) {
  if (typeof window === 'undefined') return

  window.requestAnimationFrame(() => {
    if (window.$WowheadPower?.refreshLinks) {
      window.$WowheadPower.refreshLinks()
      return
    }

    if (attempt < maxAttempts) {
      window.setTimeout(() => {
        refreshWowheadTooltips({ attempt: attempt + 1, maxAttempts, delay })
      }, delay)
    }
  })
}
